/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReserveTripsReportRow,
    ReserveTripsReportRowFromJSON,
    ReserveTripsReportRowFromJSONTyped,
    ReserveTripsReportRowToJSON,
} from './';

/**
 * GO Reserve report list
 * @export
 * @interface ReserveTripsReportList
 */
export interface ReserveTripsReportList {
    /**
     * 
     * @type {Array<ReserveTripsReportRow>}
     * @memberof ReserveTripsReportList
     */
    trips?: Array<ReserveTripsReportRow>;
}

export function ReserveTripsReportListFromJSON(json: any): ReserveTripsReportList {
    return ReserveTripsReportListFromJSONTyped(json, false);
}

export function ReserveTripsReportListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveTripsReportList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'trips': !exists(json, 'trips') ? undefined : ((json['trips'] as Array<any>).map(ReserveTripsReportRowFromJSON)),
    };
}

export function ReserveTripsReportListToJSON(value?: ReserveTripsReportList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trips': value.trips === undefined ? undefined : ((value.trips as Array<any>).map(ReserveTripsReportRowToJSON)),
    };
}


